module.exports = __webpack_public_path__ + "static/cliente_5-cb54105c312f4f02a129b0f8714aa424.png";